(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BusinessCalendar"]) return;
  try {
    

  class Calendar {
    	constructor() {
        	this.currentDate = new Date();
            this.currentMonth = this.currentDate.getMonth();
            this.currentYear  = this.currentDate.getFullYear();
            
            this.CreateCalendar(this.currentMonth, this.currentYear, false);            
            var _setMonth = this.currentMonth + 1;
            var _setYear  = this.currentYear;
            if (_setMonth >= 12) {
               _setMonth = _setMonth - 12;
               _setYear = _setYear + 1;
            }
            this.CreateCalendar(_setMonth, _setYear, true);
        }
        
        CreateCalendar(month, year, isNextMonth) {
        	const date = new Date(year, month, 1);
            const firstDay = date.getDay();
            const lastDay = new Date(year, month + 1, 0).getDate();
            const daysInPrevMonth = new Date(year, month, 0).getDate();
            const daysOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
            const calendar = document.createElement('table');
            let day = 1;
            
            calendar.setAttribute('class', 'calframe_rakuten');
            
      		var rowTitle = calendar.insertRow();
            const tableTh = document.createElement('th');
            var cellTitle = rowTitle.appendChild(tableTh);
            cellTitle.setAttribute('colspan', '7');
            cellTitle.textContent = `${year}年${month + 1}月`;
        
            var weektitleRakuten = calendar.insertRow();
            weektitleRakuten.setAttribute('class', 'weektitle_rakuten');
            for (var i = 0; i < daysOfWeek.length; i++) {
                let cell = weektitleRakuten.insertCell();
        
                if (i == 0) {
                  cell.setAttribute('style', 'color:#BF0000');
                } else if (i == 6) {
                  cell.setAttribute('style', 'color:#1D54A7');
                }
        
                cell.textContent = daysOfWeek[i];
            }
            
            month += 1;
            month % 12;
            for (let i = 0; i < 5; i++) {
                const row = calendar.insertRow();
                
                for (let j = 0; j < 7; j++) {
                    const cell = row.insertCell();
        
                  	if (i === 0 && j < firstDay) {
                    	cell.textContent = daysInPrevMonth - firstDay + j + 1;
                    	cell.style.color = '#CECECE';
                  	} else if (day > lastDay) {
                    	cell.textContent = day - lastDay;
                    	cell.style.color = '#CECECE';
                    	day++;
                  	} else {

                    	let dates = [];        
                    	let bset = false;
                    	if (!isNextMonth) {
                        	const today = this.currentDate.getDate();
                        	if (day == today) {
                            	cell.style.backgroundColor = today_color ;
                            	bset = true;
                        	}
                    	}
                    
                    	if (!bset) {
                      		if (eventDateAllDay.includes(String(j + 1))) {
                            	cell.style.backgroundColor = a_color;
                        	} else {
                            	if (month in eventCalendar) {
                                	if (eventCalendar[month].a_date.split(',').map((item) => item.trim()).includes(String(day))) {
                                    	cell.style.backgroundColor = a_color;
                                	}
                                	else if (eventCalendar[month].b_date.split(',').map((item) => item.trim()).includes(String(day))) 
                                	{
                                    	cell.style.backgroundColor = b_color;
                                	}
                                	else if (eventCalendar[month].c_date.split(',').map((item) => item.trim()).includes(String(day))) 
                                	{
                                    	cell.style.backgroundColor = c_color;
                                	}
                            	}
                        	}
                    	}
                    
                   		//土日の文字の色
                        if (j == 0) {
                          cell.style.color = '#BF0000';
                        } else if (j == 6) {
                          cell.style.color = '#1D54A7';
                        }
                    
                    
                    	// Current month
                    	cell.textContent = day;
                    	day++;
                  	}
                }
            }
            document.getElementById('business-event').appendChild(calendar);
        }
    }
  
    document.addEventListener('DOMContentLoaded', function() { 
      new Calendar(); 
    });

  } catch(e) { console.error(e); }
})();
})();
